import React from 'react';

export default function Contact() {
  return (
    <div>
      <h1>Contact Page</h1>
      <p>
        Please feel free to contact me from the list below
      </p>
       <ul>
            <li>603-540-3135</li>
            <li>c.duhaime27@gmail.com</li>
            <li><a href="https://github.com/ChrisDuhaime">GitHub</a></li>
            <li><a href="https://www.linkedin.com/in/christopher-duhaime-a31b0745/">LinkedIn</a></li>
        </ul>
    </div>
  );
}
